import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const RefreshForwardIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                d="M17.66 6.85a8 8 0 1 0 2.03 7.88 1 1 0 0 1 1.92.55 10 10 0 1 1-2.54-9.85c.64.64 1.32 1.43 1.93 2.16V6.5a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.97a33.84 33.84 0 0 0-2.31-2.65Z"
            />
        </svg>
    );
};
